// lib
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

// src
import { loginAndKeepPath } from "actions/user/thunks";

const PREFIX = "auth/";
const getTarget = (pathname) => pathname.slice(PREFIX.length);

const LoggedGate = () => {
  const { isLogged } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const target = getTarget(location.pathname);

  if (isLogged) {
    history.push(target);
  } else {
    dispatch(loginAndKeepPath(target, history));
  }
  return null;
};

export default LoggedGate;
